import { useEffect, useState } from "react";

import { ARTWORK_PROCESSING } from "@design-lab/shared";

type UploadProgressOverlayProps = {
  startTime: number | null | undefined;
};

export function UploadProgressOverlay({ startTime }: UploadProgressOverlayProps) {
  const [percent, setPercent] = useState<number>(0);

  useEffect(() => {
    if (startTime) {
      const update = () => {
        const elapsed = Math.max(0, Date.now() - startTime);
        const pct = Math.min(98, (elapsed / ARTWORK_PROCESSING.ESTIMATED_DURATION) * 100);
        setPercent(pct);
      };
      update();
      const id = setInterval(update, 100);
      return () => clearInterval(id);
    }
    setPercent(0);
    return undefined;
  }, [startTime]);

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 rounded-lg bg-black/20">
      <div className="flex w-full justify-center">
        <span className="bg-cta-gradient rounded-lg px-2 py-1 text-center text-xs font-medium leading-[18px] text-white shadow-sm">
          <span>{`Uploading... ${Math.round(percent)}%`}</span>
        </span>
      </div>

      <div className="w-3/4 rounded-full bg-white/30 p-0.5">
        <div
          className="bg-cta-gradient h-1 rounded-full transition-all duration-200"
          style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
        />
      </div>
    </div>
  );
}
